export default "/assets/images/column-image5.5b25b42937dab282.webp";